import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Salaries from "../pages/Salaries";
import Phonebooks from "../pages/Phonebooks";
import Navbar from "./Navbar";
import OrganizationsWrapper from "./OrganizationsPageComponents/OrganizationsWrapper";
import FormsByIdPage from "../pages/FormsByIdPage";

const SignedinInterface = () => {
  return (
    <div className="row">
      <div className="col-2">
        <Navbar />
      </div>
      <div className="col-10">
        <Routes>
          <Route
            exact
            path="/organizations"
            element={<OrganizationsWrapper />}
          />
          <Route exact path="/organizations/:id" element={<FormsByIdPage />} />
          <Route exact path="/salaries" element={<Salaries />} />
          <Route exact path="/phonebooks" element={<Phonebooks />} />
          <Route exact path="*" element={<Navigate to="/organizations" />} />
        </Routes>
      </div>
    </div>
  );
};

export default SignedinInterface;
